import { StyledListItemContainer } from "app/pages/sales-intelligence/pages/lists/components/common/styles";
import React from "react";
import * as styles from "./styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import SalesListItemLoader from "../../../../../common-components/sales-list-item/SalesListItemLoader";
import { HEADER_LIST_LOADING_HEIGHT, HEADER_LIST_LOADING_WIDTH } from "app/pages/sales-intelligence/constants/common";

const ListsSectionLoader: React.FC = () => {
    return (
        <styles.StyledListSection>
            <div>
                <PixelPlaceholderLoader
                    width={HEADER_LIST_LOADING_WIDTH}
                    height={HEADER_LIST_LOADING_HEIGHT}
                />
            </div>
            <styles.StyledListSectionBody>
                <StyledListItemContainer index={0}>
                    <SalesListItemLoader />
                </StyledListItemContainer>
                <StyledListItemContainer index={1}>
                    <SalesListItemLoader />
                </StyledListItemContainer>
            </styles.StyledListSectionBody>
        </styles.StyledListSection>
    );
};

export default React.memo(ListsSectionLoader);
